import { render, staticRenderFns } from "./WorkflowFolderRelaunchDialog.vue?vue&type=template&id=6b884ad9&scoped=true"
import script from "./WorkflowFolderRelaunchDialog.vue?vue&type=script&lang=js"
export * from "./WorkflowFolderRelaunchDialog.vue?vue&type=script&lang=js"
import style0 from "./WorkflowFolderRelaunchDialog.vue?vue&type=style&index=0&id=6b884ad9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b884ad9",
  null
  
)

export default component.exports